export function getToken() {
  return localStorage.getItem("SBCS-Token");
}
export function getUserInfo() {
  return JSON.parse(localStorage.getItem("SBCS-User-Info"));
}
